export default __webpack_public_path__ + "static/media/lock.d720daf3.png";